import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ProfileLayout } from 'pages/conversations/pages/search/pages/profile/layout/ProfileLayout'
import { ProfilePage } from 'pages/conversations/pages/search/pages/profile/ui/profilePage'

export const ProfileRouter = observer(() => {
  return (
    <Routes>
      <Route element={<ProfileLayout />}>
        <Route path={'/'} element={<ProfilePage />} />
        <Route path={'/:conversationId'} element={<ProfilePage />} />
      </Route>
    </Routes>
  )
})
